export default "__VITE_PUBLIC_ASSET__e183cf52__"